import React from 'react';
import Navbar from '../components/Navbar';
import SeoHead from '../components/SeoHead';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900">
      <SeoHead
        title="Conditions Générales d'Utilisation - PulseCIO"
        description="Consultez les conditions générales d'utilisation de PulseCIO, plateforme SaaS de centralisation des messages professionnels."
        breadcrumb={{ name: "CGU", path: "/terms" }}
      />
      <Navbar />
      <main className="flex-1 container mx-auto px-6 py-20">
        <h1 className="text-3xl font-bold mb-6 text-black dark:text-white">
          Conditions Générales d'Utilisation (CGU)
        </h1>
        <div className="prose dark:prose-invert max-w-none">
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Les présentes conditions générales d'utilisation définissent les droits et obligations des 
            utilisateurs du service PulseCIO.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Acceptation</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            L'utilisation du service implique l'acceptation pleine et entière des présentes CGU.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Objet</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            PulseCIO est un service visant à faciliter la gestion et le partage rapide de messages professionnels. 
            Le service est fourni par Mathieu Lalande, auto-entrepreneur.
          </p>
          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Accès et compte utilisateur
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Certains services nécessitent la création d'un compte. L'utilisateur est responsable de la 
            confidentialité de ses identifiants et de toute activité effectuée via son compte. Vous devez 
            avoir au moins 18 ans pour créer un compte. Vous ne devez pas créer de compte en utilisant 
            de fausses informations ou au nom d'une autre personne sans autorisation.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Utilisation acceptable
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Vous vous engagez à utiliser le service de manière légale et conformément aux présentes CGU. 
            Il est interdit :
          </p>
          <ul className="list-disc ml-6 mb-4 text-gray-700 dark:text-gray-300">
            <li>D'utiliser le service à des fins illégales ou frauduleuses</li>
            <li>De violer les droits de propriété intellectuelle de tiers</li>
            <li>De transmettre des virus, malwares ou tout code malveillant</li>
            <li>D'usurper l'identité d'une autre personne ou entité</li>
            <li>De harceler, menacer ou nuire à d'autres utilisateurs</li>
            <li>De tenter d'accéder de manière non autorisée au système ou aux données</li>
            <li>D'utiliser le service pour envoyer du spam ou des communications non sollicitées</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Contenu utilisateur et propriété
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Vous conservez tous les droits de propriété sur le contenu que vous créez et stockez dans le service 
            (messages, notes, tâches). En utilisant le service, vous nous accordez une licence limitée pour 
            héberger, stocker et traiter votre contenu uniquement dans le but de fournir le service. Nous ne 
            revendiquons aucun droit de propriété sur votre contenu et ne l'utilisons pas à d'autres fins.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Propriété intellectuelle
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Les contenus publiés sur le site (texte, logo, design, logiciel) sont la propriété de l'éditeur ou 
            utilisés avec autorisation. La marque PulseCIO, le logo et tous les éléments de design sont protégés. 
            Toute reproduction, distribution ou utilisation non autorisée est interdite.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Garanties et exclusions
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Le service est fourni "en l'état" et "selon disponibilité". Nous ne garantissons pas que le service 
            sera ininterrompu, sans erreur ou totalement sécurisé. Nous déclinons toute garantie implicite de 
            qualité marchande ou d'adéquation à un usage particulier, dans les limites autorisées par la loi.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Limitation de responsabilité
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            L'éditeur met en œuvre les moyens raisonnables pour assurer la disponibilité du service mais ne 
            peut garantir l'absence d'incidents. Dans les limites autorisées par la loi, notre responsabilité 
            totale ne pourra excéder le montant des frais payés par vous au cours des 12 mois précédant 
            l'événement donnant lieu à responsabilité. Nous ne serons pas responsables des dommages indirects, 
            accessoires ou consécutifs.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Abonnement et facturation
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Les abonnements sont facturés de manière récurrente (mensuelle ou annuelle selon le plan choisi). 
            Les paiements sont traités de manière sécurisée via Stripe. Les renouvellements sont automatiques 
            sauf annulation avant la date de renouvellement. Les prix peuvent être modifiés avec un préavis 
            de 30 jours.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Droit de rétractation
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Conformément au droit européen de la consommation, vous disposez d'un droit de rétractation de 
            14 jours à compter de la souscription d'un abonnement. Toutefois, en créant votre compte et en 
            utilisant le service immédiatement, vous consentez expressément à l'exécution du contrat avant 
            l'expiration du délai de rétractation et renoncez à votre droit de rétractation. Vous reconnaissez 
            que vous perdez votre droit de rétractation dès que vous commencez à utiliser le service.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Annulation et remboursements
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Vous pouvez annuler votre abonnement à tout moment depuis votre espace utilisateur. L'annulation 
            prend effet à la fin de la période de facturation en cours. Aucun remboursement ne sera accordé 
            pour la période d'abonnement en cours, sauf en cas de :
          </p>
          <ul className="list-disc ml-6 mb-4 text-gray-700 dark:text-gray-300">
            <li>Dysfonctionnement majeur du service empêchant son utilisation normale, non résolu dans un délai de 7 jours après signalement</li>
            <li>Double facturation avérée</li>
            <li>Erreur manifeste de notre part</li>
          </ul>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Les demandes de remboursement doivent être adressées à{' '}
            <a href="mailto:contact@pulsecio.com" className="text-blue-600 dark:text-blue-400 hover:underline">
              contact@pulsecio.com
            </a>{' '}
            avec justificatifs. Nous nous réservons le droit d'accorder des remboursements au cas par cas 
            selon les circonstances.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Suspension et résiliation
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Nous nous réservons le droit de suspendre ou résilier votre compte en cas de :
          </p>
          <ul className="list-disc ml-6 mb-4 text-gray-700 dark:text-gray-300">
            <li>Violation des présentes CGU</li>
            <li>Défaut de paiement</li>
            <li>Activité frauduleuse ou illégale</li>
            <li>Comportement abusif envers notre équipe ou d'autres utilisateurs</li>
          </ul>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            En cas de résiliation, vous aurez 30 jours pour exporter vos données avant leur suppression définitive.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Export et portabilité des données
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Vous pouvez à tout moment exporter vos données (messages, tâches, notes) depuis votre espace 
            utilisateur. Les exports sont disponibles au format JSON et/ou CSV selon le type de données. 
            Cette fonctionnalité garantit la portabilité de vos données conformément au RGPD.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Force majeure
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Nous ne serons pas tenus responsables de tout retard ou manquement à nos obligations résultant 
            de circonstances indépendantes de notre volonté, notamment : catastrophes naturelles, pannes 
            d'infrastructure Internet, attaques DDoS, décisions gouvernementales, grèves, ou toute autre 
            circonstance de force majeure.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">Support</h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Le support client est assuré par email. Les horaires de support sont du lundi au vendredi, 
            de 9h à 18h (heure locale).
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Modification des CGU
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            L'éditeur se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront 
            informés des modifications importantes par email ou via une notification sur le site. L'utilisation 
            continue du service après modification vaut acceptation des nouvelles conditions.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3 text-black dark:text-white">
            Droit applicable
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4">
            Les présentes CGU sont soumises au droit français. En cas de litige, et après tentative de résolution 
            amiable, les tribunaux français seront seuls compétents.
          </p>
        </div>
      </main>
      <div className="w-full flex justify-center mt-12 mb-2">
        <a href="/" className="inline-flex items-center px-5 py-2 rounded-lg bg-blue-600 text-white font-semibold shadow hover:bg-blue-700 transition">
          ← Retour à la page principale
        </a>
      </div>
      <Footer />
    </div>
  );
};

export default Terms;